export default function FaqData() {
  return [
    {
      title: "What is decreasing term life insurance?",
      text: ["Decreasing term life insurance is designed to mirror the amortization schedule of a mortgage or other personal debt like personal loans or business loans. The monthly cost for the level-premium decreasing term plan does not change."]
    },
    {
      title: "What is a collateral assignment?",
      text: ["A collateral assignment of life insurance is a conditional agreement that appoints a lender as the primary beneficiary of a death benefit used as collateral for a loan. In the event of the borrower's death, the lender will receive the amount owed on their loans through the death benefit, and the remaining balance will be directed to other listed beneficiaries."]
    },
    {
      title: "Will my premiums increase during the term of coverage?",
      text: ["Term insurance typically is guaranteed to not increase for the initial term of the policy. In addition, once you are approved your coverage cannot be rescinded, even if your health changes down the road.",]
    },
    {
      title: "What are the premium rates based on?",
      text: ["Premiums are based on several different factors, including age, gender, tobacco use, and the term and amount of insurance coverage you choose.",]
    },
    {
      title: "When will my coverage begin?",
      text: ["Your coverage becomes effective after your application is approved and the carrier receives your first premium payment. Once your application is approved, you will also receive your policy which will include information confirming the billing method, timing of the first premium due and all subsequent premium payment dates thereafter."]
    },
    {
      title: "What is life insurance?",
      text: ["Life Insurance is a financial planning tool that pays tax-free a specific amount of money to family, friends, or other beneficiaries in the event of death. There are many variations in life insurance terms and benefits that can be customized to meet your needs."]
    },
    {
      title: "What's the difference between Term and Permanent Life Insurance?",
      text: ["Broad categories of Life insurance include Permanent and Term coverage. Term Insurance is an excellent option for low budget temporary coverage. Because of its temporary nature, it isn't as valuable or flexible as permanent coverage.",
        "Permanent Life Insurance can provide benefits in many ways, including coverage that remains in force for one's whole life. It can also be used for long-term savings, supplemental retirement, and offers various tax advantages."]
    },
    {
      title: "Why purchase life insurance?",
      text: ["The reason someone purchases life insurance may vary. Purchase decisions range from tax planning to protecting your family financially in the event of an unexpected death. In most cases, life insurance is the best option to protect your family in the following ways:",
        [
          "Providing for children or dependents",
          "Income replacement",
          "Funeral expenses",
          "Education expense protection",
          "Debt payoff"
        ],
      ],
    },
    {
      title: "Why not purchase Life Insurance?",
      text: ["When people ask us why they should purchase life insurance, we first ask why they shouldn't. Some answers may surprise you.",
        [
          "You have sufficient savings to self-insure against loss",
          "No one is dependent upon your income",
          "Single without any obligations",
          "You are over the age of 85"
        ],
      ],
    },
    {
      title: "What does the underwriting process consider?",
      text: ["The criteria that are analyzed by a life insurance underwriter can include the following:",
        [
          "Applicant’s current age",
          "Applicant’s gender",
          "Height and weight of the applicant",
          "Health history (in addition to family health history of the applicant’s parents and siblings)",
          "The purpose of the insurance policy (estate planning, business, or individual life insurance)",
          "Applicant’s marital status",
          "Applicant’s children, if any",
          "The amount of life insurance already in force by the applicant, as well as any additional life insurance that the applicant intends to purchase",
          "Applicant’s occupation",
          "Applicant’s income as income can help determine the suitability of the amount of life insurance",
          "Applicant’s smoking habits or tobacco use",
          "Use of alcohol by the applicant",
          "Hobbies that the applicant engages in. Some hobbies are considered hazardous, such as rock climbing or hang gliding and are considered high risk.",
          "Amount of foreign travel that the applicant engages in as some types of foreign travel are considered risky"
        ],
        "All of the above factors are considered to be elements of risk. Each is analyzed and factored in by the life insurance underwriters prior to an approval or rejection decision being made. Therefore, prior to applying for life insurance coverage, it is important to understand how underwriting works, as well as how different factors could affect the possibility of being accepted or rejected for coverage. Those applicants who have been rejected due to risk factors can still apply for high risk life insurance."
      ],
    },
    {
      title: "Why do I have to provide my email address?",
      text: ["As much of the process is internet based this application process requires that you enter your email address so that we can email you a link to e-sign your application."],
    },
    {
      title: "What if I withhold pertinent information?",
      text: ["If it sounds tempting to shortcut this process by withholding information or outright lying, don’t do it. Policies that were sold based on applications that contained misleading information can be voided at claim time. False information on insurance applications is fraud.",
        "Insurers will likely report your medical exam results (reported as numbered codes) to MIB (formerly called the Medical Information Bureau), which maintains a database of those who have applied for life, health, disability and other insurance in the last seven years. If you've given different answers to medical questions in the past, it will raise a red flag with MIB. The goal of the MIB database is to reduce fraud."
      ],
    },
    {
      title: "What is the decision that will be made?",
      text: ["One of four things will happen:",
        [
          "Your coverage will be approved at the same rate for which you applied.",
          "Your coverage will be approved at a cheaper rate than that for which you applied.",
          "Additional premium will be required for the amount of insurance for which you applied.",
          "Coverage will be denied."
        ],
        "In the event that coverage is denied or you are quoted a higher premium we will work with you to review alternatives."
      ],
    }
  ]
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Americo/FaqData.js